var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row flex-align-center"},[_c('i',{staticClass:"mr-4",class:_vm.statusIcon}),_c('span',{staticClass:"fz-12"},[_vm._v(_vm._s(_vm.statusDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }